import React, { useState } from 'react';
import Button from '../common/Button';
import { TextInput } from '../common/TextInput';
import {Modal} from '../common/Modal';
import dayjs from 'dayjs';

interface AddCartonBoxModalProps {
  onClose: () => void;
  onAdd: (boxData: any) => void;
}

const AddCartonBoxModal: React.FC<AddCartonBoxModalProps> = ({ onClose, onAdd }) => {
  const [boxData, setBoxData] = useState({
    size1: '',
    size2: '',
    size3: '',
    weight: '',
    deliveredAt: dayjs().set('hour', 10).set('minute', 0).set('second', 0).set('millisecond', 0).format('YYYY-MM-DDTHH:mm'),
  });

  const handleAdd = () => {
    onAdd({
      size1: boxData.size1 ? parseFloat(boxData.size1) : null,
      size2: boxData.size2 ? parseFloat(boxData.size2) : null,
      size3: boxData.size3 ? parseFloat(boxData.size3) : null,
      weight: boxData.weight ? parseFloat(boxData.weight) : null,
      deliveredAt: boxData.deliveredAt || null,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleAdd();
  };

  return (
    <Modal onClose={onClose} title="Add Carton Box">
      <form className="p-6" onSubmit={handleSubmit}>
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-4">
            Enter the dimensions and weight of the carton box.
          </p>

          <div className="grid grid-cols-3 gap-2 mb-4">
            <TextInput
              label="Size 1 (cm)"
              type="number"
              value={boxData.size1}
              onChange={(e) => setBoxData({ ...boxData, size1: e.target.value })}
              placeholder="Length"
            />
            <TextInput
              label="Size 2 (cm)"
              type="number"
              value={boxData.size2}
              onChange={(e) => setBoxData({ ...boxData, size2: e.target.value })}
              placeholder="Width"
            />
            <TextInput
              label="Size 3 (cm)"
              type="number"
              value={boxData.size3}
              onChange={(e) => setBoxData({ ...boxData, size3: e.target.value })}
              placeholder="Height"
            />
          </div>

          <div className="mb-4">
            <TextInput
              label="Weight (kg)"
              type="number"
              value={boxData.weight}
              onChange={(e) => setBoxData({ ...boxData, weight: e.target.value })}
              placeholder="0.00"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Delivered At (optional)
            </label>
            <input
              type="datetime-local"
              value={boxData.deliveredAt}
              onChange={(e) => setBoxData({ ...boxData, deliveredAt: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit">Add Box</Button>
        </div>
      </form>
    </Modal>
  );
};

export default AddCartonBoxModal;

